const common = {
    // root: ['https://fqyf.wts9999.net', 'https://www.fxyf99.com', 'https://fqyf.wts9999.net','http://prepare.fxyf99.com'], //
    env: process.env.environment, //环境 0测试 1正式 2本地 3预发布 4北京分区
}
// 获取 页面公共变量
common.api_root = common.env==2?'https://fqyf.wts9999.net':location.origin;
common.appid = common.env==0?'wx04452e22173121e5':'wx1a86bb7e7f5e7797';
export default common



// WEBPACK FOOTER //
// ./src/api/common.js